import { render, staticRenderFns } from "./CR_sinoRussianRailway.vue?vue&type=template&id=1670c141&"
import script from "./CR_sinoRussianRailway.vue?vue&type=script&lang=js&"
export * from "./CR_sinoRussianRailway.vue?vue&type=script&lang=js&"
import style0 from "./CR_sinoRussianRailway.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports